export default __webpack_public_path__ + "static/media/Group 19651.63835820.png";